export default class MismatchedOAuthError extends Error {
    dpError;
    constructor() {
        const message = 'Google and DevicePilot account e-mail address must match';
        super(message);
        this.dpError = true;
    }
}
